export default __webpack_public_path__ + "static/plus-dark-mode-3d909fbb8d329e6bd33f46b7463bd35f.mp4";